import { apiGet, getDeviceType } from "../../utils";


export function DownloadCSVAllDevicesAPI() {
    return apiGet(process.env.REACT_APP_DEVICE_CSV_DOWNLOAD +  `/device/export?deviceType=${getDeviceType()}`)
}